<template>
    <div>
        <v-card flat class="mt-2">
            <!-- {{ user }} -->
            <v-form class="multi-col-validation">
                <v-card-title>PPDS</v-card-title>
                <v-card-text class="">
                    <v-alert type="warning" v-if="userTambahan.verified_by == null">Data anda belum diverifikasi oleh
                        admin. Silahkan cek data anda</v-alert>
                    <v-row>
                        <v-col cols="6" md="3">
                            <v-text-field v-model="userTambahan.username" label="Username :" dense outlined
                                readonly></v-text-field>
                        </v-col>
                        <v-col cols="6" md="3">
                            <v-text-field v-model="userTambahan.email" label="Email :" dense outlined
                                readonly></v-text-field>
                        </v-col>
                        <v-col cols="6" md="3">
                            <v-text-field v-model="userTambahan.nama" label="Nama :" dense outlined></v-text-field>
                        </v-col>
                        <v-col cols="6" md="3">
                            <v-text-field v-model="userTambahan.nim" label="NIM :" dense outlined></v-text-field>
                        </v-col>
                        <v-col cols="6" md="3">
                            <v-autocomplete v-model="userTambahan.id_institusi" :items="institusi_pendidikans" outlined
                                dense label="Institusi Pendidikan :" item-text="nama" item-value="id"></v-autocomplete>
                        </v-col>
                        <v-col cols="6" md="3">
                            <v-autocomplete v-model="userTambahan.id_prodi" :items="prodis" outlined dense
                                label="Prodi :" item-text="nama" item-value="id"></v-autocomplete>
                        </v-col>
                        <v-col cols="6" md="3">
                            <v-text-field v-model="userTambahan.level" label="Level :" dense outlined></v-text-field>
                        </v-col>
                    </v-row>
                    Upload Dokumen :
                    <v-simple-table dense>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        No
                                    </th>
                                    <th class="text-left">
                                        Nama
                                    </th>
                                    <th class="text-left">
                                        File
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, index) in dokumens" v-bind:key="item.id">
                                    <td>{{ parseInt(index) + 1 }}</td>
                                    <td>{{ item.nama }}</td>
                                    <td><uploaded-dokumen-registrasi-user :namaDokumen="item.kode"
                                            :userTambahan="userTambahan"></uploaded-dokumen-registrasi-user></td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card-text>
            </v-form>
        </v-card>
    </div>
</template>

<script>
import axios from 'axios'
import UploadedDokumenRegistrasiUser from '@/components/upload/UploadedDokumenRegistrasiUser.vue'
import { axiosPostAuth, axiosGetAuth } from '@/utils/axios'

const apiRoot = process.env.VUE_APP_APIROOT
export default {
    components: {
        UploadedDokumenRegistrasiUser,
    },
    data: () => ({
        userTambahan: {
            username: '',
            email: '',
            nama: '',
            nim: '',
            institusi_pendidikan: '',
            prodi: '',
            jenis_kelamin: '',
            alamat: '',
            level: '',
        },
        dokumens: [],
        institusi_pendidikans: [],
        prodis: [],
    }),
    computed: {
        headers() {
            return {
                Authorization: this.$store.state.token,
            }
        },
        user() {
            return this.$store.getters.user
        },
    },
    watch: {
    },
    created() {
        this.getData()
        this.getInstitusiPendidikan()
        this.getProdi()
        this.getDokumenRequirement()
    },
    methods: {
        getDokumenRequirement() {
            let fmData = new FormData();
            fmData.append('profesi', 'PPDS')
            axiosPostAuth('api/RegisterLanjutan/getDokumenRequirement', fmData)
                .then(response => {
                    this.dokumens = Object.assign({}, response.data)
                })
        },
        getData() {
            let fmData = new FormData();
            fmData.append('user_id', this.user.id)
            axiosPostAuth('api/User/getUser', fmData)
                .then(response => {
                    this.userTambahan = Object.assign({}, response.data)
                })
        },
        getInstitusiPendidikan() {
            const headers = this.headers
            axios
                .get(`${apiRoot}/api/RegisterLanjutan/getInstitusiPendidikans`, { headers })
                .then(response => {
                    if (response.data.code === 200) {
                        this.institusi_pendidikans = response.data.datas
                    } else {
                        alert(response.data.message)
                    }
                })
                .catch(error => {
                    alert(error)
                })
        },
        getProdi() {
            const headers = this.headers
            axios
                .get(`${apiRoot}/api/RegisterLanjutan/getProdis`, { headers })
                .then(response => {
                    if (response.data.code === 200) {
                        this.prodis = response.data.datas
                    } else {
                        alert(response.data.message)
                    }
                })
                .catch(error => {
                    alert(error)
                })
        },
        simpan() {
            const headers = this.headers
            const fmData = new FormData()
            fmData.append('username', this.userTambahan.username)
            fmData.append('email', this.userTambahan.email)
            fmData.append('nama', this.userTambahan.nama)
            fmData.append('nim', this.userTambahan.nim)
            fmData.append('institusi_pendidikan', this.userTambahan.institusi_pendidikan)
            fmData.append('prodi', this.userTambahan.prodi)
            fmData.append('level', this.userTambahan.level)
            const dokumen = [];
            this.userTambahan.dokumen.forEach(element => {
                dokumen.push(element.id)
            });
            fmData.append('dokumen', dokumen)
            fmData.append('role_temp', this.user.role_temp)
            axios
                .post(`${apiRoot}/api/RegisterLanjutan/addRegistrasiPesertaPpds`, fmData, { headers })
                .then(response => {
                    if (response.data.code === 200) {
                        this.$store.dispatch('logout', response.data.message)
                    } else {
                        alert(response.data.message)
                    }
                })
                .catch(error => {
                    alert(error)
                })
        },
    },
}
</script>